import { Page } from 'layouts/Page';
import { FC } from 'react';
import { SecuritySettings } from 'components/SecuritySettings';

export const SecuritySettingsPage: FC = () => {
	return (
		<Page title="Security settings – EAS Dashboard">
			<SecuritySettings />
		</Page>
	);
};
